interface JSONValue {
  [key: string]: JSONValue
}

export enum SectionDataSource {
  CATEGORIES = "CATEGORIES",
  DISCOUNTED_PRODUCTS = "DISCOUNTED_PRODUCTS",
  RECOMMENDED_PRODUCTS = "RECOMMENDED_PRODUCTS",
  COLLECTIONS = "COLLECTIONS",
  RECENTLY_VIEWED_PRODUCTS = "RECENTLY_VIEWED_PRODUCTS",
  PRODUCTS = "PRODUCTS",
  MOST_VIEWED_PRODUCTS = "MOST_VIEWED_PRODUCTS",
  BEST_SELLER_PRODUCTS = "BEST_SELLER_PRODUCTS",
}

export enum SectionType {
  SLIDE_CAROUSEL = "SLIDE_CAROUSEL",
  GRID = "GRID",
}

export enum ItemType {
  CATEGORY = "CATEGORY",
  COLLECTION = "COLLECTION",
  PRODUCT = "PRODUCT",
}

export interface SectionTitle {
  es: string
  en: string
}

export interface MarketPlaceSection {
  id: string
  title?: SectionTitle
  source: SectionDataSource
  filter?: Record<string, string | number | string[] | number[]>
  type: SectionType
  rows?: number
  columns: number
  maxItems: number
  hideItemsTitle?: boolean
}

export interface MarketPlaceStructure {
  sections: MarketPlaceSection[]
}

export type AppFeatures = {
  marketplace_home_structure: MarketPlaceStructure | JSONValue
}

const isMarketPlaceStructure = (structure: any) => {
  if (typeof structure !== "object" || structure === null) return false
  if (!Array.isArray(structure.sections)) return false
  return true
}

const isMarketPlaceSection = (section: any) => {
  if (typeof section !== "object" || section === null) return false
  if (typeof section.id !== "string") return false
  if (typeof section.source !== "string") return false
  if (!Object.values(SectionDataSource).includes(section.source)) return false
  if (typeof section.type !== "string") return false
  if (!Object.values(SectionType).includes(section.type)) return false
  if (section.rows !== undefined && typeof section.rows !== "number") return false
  if (typeof section.columns !== "number") return false
  if (typeof section.maxItems !== "number") return false
  if (section.hideItemsTitle !== undefined && typeof section.hideItemsTitle !== "boolean") return false
  if (section.title !== undefined) {
    if (typeof section.title.es !== "string" || typeof section.title.en !== "string") return false
  }
  if (section.filter !== undefined) {
    if (!Array.isArray(section.filter.categories)) return false
    for (const category of section.filter.categories) {
      if (typeof category !== "string") return false
    }
    if (section.filter.maxPrice !== undefined && typeof section.filter.maxPrice !== "number") return false
  }
  return true
}

export const castToMarketPlaceStructure = (value: any): MarketPlaceStructure | null => {
  const isStructured = isMarketPlaceStructure(value)
  if (isStructured) {
    return {
      sections: value.sections.filter(isMarketPlaceSection).map((section: any) => {
        return {
          id: section.id,
          source: section.source,
          type: section.type,
          rows: section.rows,
          columns: section.columns,
          maxItems: section.maxItems,
          hideItemsTitle: section.hideItemsTitle,
          title: section.title,
          filter: section.filter,
        }
      }),
    }
  } else {
    return null
  }
}
